import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import type { Property } from 'csstype';
import ImageButton from '../molecules/ImageButton.View';
import type {
	DispatchProps as ImageButtonDispatchProps,
	OwnProps as ImageButtonOwnProps,
	StateProps as ImageButtonStateProps
} from '../molecules/ImageButton.View';
import type { PositionProps, SizeProps } from '../../utils/styledcomponents';
import type { Persona } from '../../data/Personas';
import { getImageComponentByKey } from '../../assets/Assets';

export type StateProps = ImageButtonStateProps;
export type DispatchProps = ImageButtonDispatchProps;
interface PersonaIconProps<T = string | number> {
	className?: string;
	x: Property.Left<T>;
	y: Property.Top<T>;
	persona: Persona;
	negative?: boolean;
	onClick?: (persona: Persona) => void;
}
export type OwnProps = Omit<
	ImageButtonOwnProps,
	'src' | 'shadow' | 'onClick' | keyof PositionProps | keyof SizeProps
> &
	PersonaIconProps;

export type Props = StateProps & DispatchProps & OwnProps;

const PersonaIcon: FunctionComponent<Props> = (props: Props) => {
	const { persona, negative = false, onClick, x, y, ...otherProps } = props;

	const image = useMemo(
		() =>
			getImageComponentByKey(
				negative ? persona.images.face.negative : persona.images.face.positive
			),
		[negative, persona]
	);

	return (
		<ImageButton
			src={image}
			width="12vmin"
			height="16vmin"
			position="absolute"
			left={`calc(${x} - 6vmin)`}
			top={`calc(${y} - 8vmin)`}
			onClick={onClick ? () => onClick(persona) : undefined}
			{...otherProps}
		/>
	);
};

export default PersonaIcon;
